export default "__VITE_ASSET__38af0c17__"